'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../node_modules/tslib/tslib.es6.js');
var React = require('react');
var valign = require('../../units/valign.js');
var vblur = require('../../units/vblur.js');
var vborder = require('../../units/vborder.js');
var vdir = require('../../units/vdir.js');
var vpadding = require('../../units/vpadding.js');
var vrounded = require('../../units/vrounded.js');
var vshadow = require('../../units/vshadow.js');
var vspacer = require('../../units/vspacer.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function toStyle(config) {
  var classList = " ".concat(vdir.VDirection.toStyle(config.direction || vdir.VDirection.default), " ").concat(valign.VAlign.toStyle(config.align || valign.VAlign.default));

  if (config.spacer && config.spacer != vspacer.VSpacer.none) {
    classList += " ".concat(vspacer.VSpacer.toStyle(config.spacer));
  }

  if (config.padding && config.padding != vpadding.VPadding.none) {
    classList += " ".concat(vpadding.VPadding.toStyle(config.padding));
  }

  if (config.rounded && config.rounded != vrounded.VRounded.none) {
    classList += " ".concat(vrounded.VRounded.toStyle(config.rounded));
  }

  if (config.border && config.border != vborder.VBorder.none) {
    classList += " ".concat(vborder.VBorder.toStyle(config.border));
  }

  if (config.shadow && config.shadow != vshadow.VShadow.none) {
    classList += " ".concat(vshadow.VShadow.toStyle(config.shadow));
  }

  if (config.blur && config.blur != vblur.VBlur.none) {
    classList += " ".concat(vblur.VBlur.toStyle(config.blur));
  }

  return classList;
}

var VAutoLayout = function (_a) {
  var children = _a.children,
      _b = _a.className,
      className = _b === void 0 ? '' : _b,
      _c = _a.vstyle,
      vstyle = _c === void 0 ? {} : _c;
      tslib_es6.__rest(_a, ["children", "className", "vstyle"]);

  var classList = "vlayout-auto ".concat(toStyle(vstyle), " ").concat(className);
  return React__default["default"].createElement("div", {
    className: classList
  }, React__default["default"].createElement(React__default["default"].Fragment, null, children));
};

exports["default"] = VAutoLayout;
